import { Component, inject, OnInit } from '@angular/core';

import {NotificationsFacade} from "./../../+state/notifications.facade";

@Component({
    selector: 'qwyk-notifications-page',
    templateUrl: './notifications-page.component.html',
    styleUrls: ['./notifications-page.component.scss']
})
export class NotificationsPageComponent implements OnInit {

    private notifications = inject(NotificationsFacade);

    public notifications$ = this.notifications.allNotifications$;
    public loading$ = this.notifications.loading$;
    public error$ = this.notifications.error$;
    public pagination$ = this.notifications.pagination$;
    private query = {page: 1, pageSize: 25};

    ngOnInit(): void {
        this.loadQuotations(this.query);
    }

    public onPageChange(e: {page: number, pageSize: number}): void {
        this.loadQuotations(e);
    }

    private loadQuotations(query: {page: number, pageSize: number}): void {

        this.query = query;
        this.notifications.loadNotifications(this.query);

    }

}
